const onlyNumbers = (value) => {
  if (!value) return '';
  return value.replace(/[^\d]/g, '');
};

export const normalizeMoney = (value) => {
  const onlyNums = onlyNumbers(value ? value.toString() : '');
  if (onlyNums === '') {
    return '';
  }
  try {
    const formatter = new Intl.NumberFormat('nb-NB', {
      style: 'decimal',
    });
    return formatter.format(onlyNums);
  } catch (e) {
    return onlyNums;
  }
};

export const normalizePostnummer = (value) => {
  const onlyNums = onlyNumbers(value ? value.toString() : '');
  if (onlyNums === '') {
    return '';
  }
  if (onlyNums.length > 4) {
    return onlyNums.substring(0, 4);
  }
  return onlyNums;
};
